import { render, staticRenderFns } from "./modal-payment.vue?vue&type=template&id=36b0a676&scoped=true"
import script from "./modal-payment.vue?vue&type=script&lang=js"
export * from "./modal-payment.vue?vue&type=script&lang=js"
import style0 from "./modal-payment.vue?vue&type=style&index=0&id=36b0a676&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b0a676",
  null
  
)

export default component.exports